import '../fixtures_match_list/index.css';
import { useEffect, useState } from 'react';
import useGame from '../../../utilities/hooks/game';
import Constants from '../../../constants';
import { useDispatch } from 'react-redux';
import { useLink } from 'react-router-stack';
import { getRouteObjByGame, isSmartPhone } from '../../../utilities/helper';
import CompletedMatchListMWeb from './index_mWeb';
import CompletedMatchListWeb from './index_web';

const CompletedMatchList = ({ list }: any) => {
  const dispatch = useDispatch();
  const navigate = useLink();
  const { gameType, fantasyMatchClick } = useGame();
  const [resultMatchList, setResultMatchList] = useState([] as any);

  useEffect(() => {
    setResultMatchList([...list]);
  }, []);

  const onPressMatchCard = (matchItem: any) => {
    const { adminVerified = false, verified: _verified = false } = matchItem;
    const verified = gameType === Constants.GameType.FANTASY_YES_NO ? adminVerified : _verified;
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          verified,
          completed: true,
          joined: false,
          joinedMatch: true,
          contestId: '',
          entryFee: '',
          isTeamSwitch: false,
          tabType: 'RESULT'
        }
      })
    );

    navigate.push(getRouteObjByGame(gameType)['my_contests']);
  };

  const onPressAddSubstitute = () => {};
  if (isSmartPhone) {
    return (
      <CompletedMatchListMWeb
        resulMatchList={resultMatchList}
        onPressMatchCard={onPressMatchCard}
        onPressAddSubstitute={onPressAddSubstitute}
        gameType={gameType}
      />
    );
  } else {
    return (
      <CompletedMatchListWeb
        resulMatchList={resultMatchList}
        onPressMatchCard={onPressMatchCard}
        onPressAddSubstitute={onPressAddSubstitute}
        gameType={gameType}
      />
    );
  }
};

export default CompletedMatchList;
